import { translateFn } from '../../utils/translator.helper';

export async function openConsoleForCurrentUserAndCompany(companyId: string, dependencies: any): Promise<void> {
  const errorMessage = translateFn('Unexpected error occurred while opening the Mobile Security console.');
  let response;

  try {
    response = await dependencies.api.clients.MobileSecurity.openConsoleForCurrentUserAndCompany(companyId).toPromise();
  } catch (error) {
    throw new Error(errorMessage);
  }

  if (!response || !response.success) {
    throw new Error(errorMessage);
  }
}
